import { Injectable } from '@angular/core';
import { RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  constructor(private router: Router,
    private authService: AuthService) { }

  canActivate(state: RouterStateSnapshot): boolean {
 
    if (this.authService.isUserLoggedIn()) {
      let redirectUrl = '/'+this.authService.getRedirectUrl()?this.authService.getRedirectUrl():'dashboard';
      
      this.router.navigateByUrl(redirectUrl);
     
      return false;
    }
    return true;
  }
}
